module.exports = __webpack_public_path__ + "assets/b0.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b0.png
// module id = 568
// module chunks = 0